<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Detail Kas Mutasi</h5>
            </template>
            <div class="detail-data-wrapper mb-4">
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Dari Cabang</b-col>
                    <b-col>{{ kasMutasi.dari.name }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Ke Cabang</b-col>
                    <b-col>{{ kasMutasi.tujuan.name }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Nominal</b-col>
                    <b-col>
                        <strong v-if="kasMutasi.nominal == null">{{$helper.addThousandSeparator(kasMutasi.nominal)}} </strong>
                        <strong v-else-if="kasMutasi.nominal < 0">- Rp{{$helper.addThousandSeparator(kasMutasi.nominal).replace("-", "")}}</strong>
                        <strong v-else>Rp. {{$helper.addThousandSeparator(kasMutasi.nominal)}} </strong>
                    </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Tanggal</b-col>
                    <b-col>{{ $helper.changeDateFormat(kasMutasi.tanggalPembuatan) }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Status</b-col>
                    <b-col>{{ kasMutasi.status.name }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Dikirim oleh</b-col>
                    <b-col v-if="kasMutasi.sendBy.id != null">{{ kasMutasi.sendBy.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Disetujui oleh</b-col>
                    <b-col v-if="kasMutasi.approvedBy.id != null">{{ kasMutasi.approvedBy.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Keterangan</b-col>
                    <b-col v-if='kasMutasi.keterangan != null && kasMutasi.keterangan != ""'>{{ kasMutasi.keterangan }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>
            <b-form-group class="form-inline mb-3">
                <b-button class="mr-2" v-if="kasMutasi.dari.id == cabangId && kasMutasi.status.id == 1" variant="success" name="kasMutasiKirimBtn" @click="openModalKirim">Kirim</b-button>
                <b-button class="mr-2" v-if="kasMutasi.tujuan.id == cabangId && kasMutasi.status.id == 2" variant="success" name="kasMutasiApproveBtn" @click="openModalConfirm">Setujui</b-button>
                <b-button class="mr-2" v-if="((role == 'Head Office' || kasMutasi.dari.id == cabangId) && (kasMutasi.status.id == 1 || kasMutasi.status.id == 2))" variant="danger" name="kasMutasiCancelBtn" @click="openModalCancel">Batalkan</b-button>
                <b-button variant="pgiBtn" name="kasMutasiBackBtn" @click="backToKasMutasi">Kembali</b-button>
            </b-form-group>
        </b-card>
        <ModalConfirm id="modal-kirim-kas-mutasi" title="Confirm Kirim Kas Mutasi" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk mengirim kas mutasi ini?" @submit="kirimKasMutasi" />
        <ModalConfirm id="modal-cancel-kas-mutasi" title="Confirm Batalkan Kas Mutasi" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk membatalkan kas mutasi ini?" @submit="cancelKasMutasi" />
        <ModalConfirm id="modal-approve-kas-mutasi" title="Confirm Approve Kas Mutasi" :isSubmitting="isSubmitting" desc="Apakah anda yakin untuk menyetujui kas mutasi ini?" @submit="approveKasMutasi" />
    </div>
</template>

<script>
export default {
    name: 'detail-kas-mutasi',
    data(){
        return{
            id: null,
            role: null,
            isSubmitting: false,
            initStatus: 0,
            cabangId: 0,
            kasMutasi: []
        }
    }, 

    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.cabangId = this.$helper.getCabangId()
            this.id = this.$route.params.id
            
            this.role = localStorage.role

            let getSingleKasMutasi = this.$axios.get(`cabang/kas/mutasi/${this.id}`).then(response => {
                this.kasMutasi = response.data

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getSingleKasMutasi]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },


        //----------------- Fungsi Lain -----------------

        approveKasMutasi(){
            let payload = new FormData()

            payload.append("mutasiId", this.id)

            this.isSubmitting = true

            this.$axios.post("cabang/kas/mutasi/approve", payload).then(() => {
                this.$helper.setFlash(`Kas Mutasi berhasil disetujui!`)
                let path = this.$route.path.split('/')
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        kirimKasMutasi(){
            let payload = new FormData()

            payload.append("mutasiId", this.id)

            this.isSubmitting = true

            this.$axios.post("cabang/kas/mutasi/kirim", payload).then(() => {
                this.$helper.setFlash(`Kas Mutasi berhasil dikirim!`)
                let path = this.$route.path.split('/')
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        cancelKasMutasi(){
            let payload = new FormData()

            payload.append("mutasiId", this.id)

            this.isSubmitting = true

            this.$axios.post("cabang/kas/mutasi/batal", payload).then(() => {
                this.$helper.setFlash(`Kas Mutasi berhasil dibatalkan!`)
                let path = this.$route.path.split('/')
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        openModalConfirm(){
            this.$bvModal.show("modal-approve-kas-mutasi")
        },

        openModalKirim(){
            this.$bvModal.show("modal-kirim-kas-mutasi")
        },

        openModalCancel(){
            this.$bvModal.show("modal-cancel-kas-mutasi")
        },

        backToKasMutasi(){
            let path = this.$route.path.split("/")
            path.pop()
            path = path.join("/")
            this.$router.push({ path })
        },
    },

    created(){
        this.init()
    }
}
</script>
